


































































































































































































import {
  GeekItem,
} from '@/models';
import {
  Level,
  OpportunityItemStatus,
  OpportunityItemBasicStatus,
  OpportunityItemDefaultStatus,
  OpportunityItemBasicDefaultStatus,
  Tag,
} from '@/models/opportunities';
import {buildGeekFullName} from '@/utils';
import {typedStore, Actions} from '@/store';
import debounce from 'lodash.debounce';
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import OpportunityIcon from './OpportunityIcon.vue';

export default Vue.extend({
  name: 'OpportunityFilter',
  components: {
    Multiselect,
    OpportunityIcon,
  },
  data() {
    return {
      levels: Object.values(Level),
      statuses: Object.values(OpportunityItemStatus),
      basicStatuses: Object.values(OpportunityItemBasicStatus),
      filters: {
        debounce: {
          opportunityStatuses: [] as OpportunityItemStatus[],
          opportunityLevels: [],
          opportunityTags: [] as Tag[],
          issuers: [] as GeekItem[],
          searchPhrase: '',
        },
        immediate: {
          createdByMe: false,
          participateIn: false,
        },
      },
    };
  },
  async created() {
    await this.$store.dispatch(Actions.opportunities.fetchTags);
    await this.$store.dispatch(Actions.opportunities.fetchPopularTags);
    await this.$store.dispatch(Actions.opportunities.fetchCreators);
  },
  mounted() {
    this.filters.debounce.opportunityStatuses =
      this.$isAccessible(this.$opportunityPermissions.addNewOpportunity)
        ? Object.values(OpportunityItemDefaultStatus) as unknown as OpportunityItemStatus[]
        : Object.values(OpportunityItemBasicDefaultStatus) as unknown as OpportunityItemStatus[];
  },
  computed: {
    allTags(): Tag[] {
      return typedStore(this).state.opportunities.tags;
    },
    popularTags(): Tag[] {
      return typedStore(this).state.opportunities.popularTags;
    },
    // List of all geeks that can create opportunity and manage them
    issuers(): GeekItem[] {
      return typedStore(this).state.opportunities.creators;
    },
  },
  methods: {
    toggleParticipateIn() {
      this.filters.immediate.participateIn = !this.filters.immediate.participateIn;
    },
    toggleCreatedByMe() {
      this.filters.immediate.createdByMe = !this.filters.immediate.createdByMe;
    },
    toggleTag(tag: Tag) {
      const tagIndex = this.findTagIndex(tag);
      tagIndex > -1
        ? this.filters.debounce.opportunityTags.splice(tagIndex, 1)
        : this.filters.debounce.opportunityTags.push(tag);
    },
    findTagIndex(tag: Tag): number {
      return this.filters.debounce.opportunityTags.findIndex((t: Tag) => t.id === tag.id);
    },
    limitText(count: number): string {
      const s = count > 1 ? 's' : '';
      return this.$t(`opportunities.list.filters.geek${s}-limit-text`, {count}) as string;
    },
    updateSearchPhrase(this: any) {
      this.filters.debounce.searchPhrase = this.$refs.searchPhrase.$el.value;
    },
    emitFilters() {
      // filters deep copy is created to prevent data mutation
      const filters = {...this.filters.debounce, ...this.filters.immediate};
      const filtersCopy = JSON.parse(JSON.stringify(filters));
      Object.keys(filtersCopy).forEach((key, index) => {
        if (Array.isArray(filtersCopy[key])) {
          filtersCopy[key] = filtersCopy[key].map((v: any) => v.id ? v.id : v);
        }
      });
      this.$emit('updateFilters', filtersCopy);
    },
    buildGeekFullName,
  },
  watch: {
    'filters.debounce': {
      handler: debounce(function(this: any) {
        this.emitFilters();
      }, 1000),
      deep: true,
    },
    'filters.immediate': {
      handler(this: any) {
        this.emitFilters();
      },
      deep: true,
    },
  },
});
